import React from 'react';
import { getColourOfStat, getDifferenceInStringifiedStats } from 'utils/data-vis-helpers';
import styles from './style.module.scss';
import { TryScrambleText } from 'utils/text-scrambler';

export interface Props {
  isBlurred: boolean;
  label: string;
  city: string | number;
  neighbourhood?: string | number;
  isPercentage?: boolean;
}

export default function ChartStatTableRow({ isBlurred, label, city, neighbourhood, isPercentage = true }: Props) {
  const formatDisplayValue = (value: string | number | undefined) => {
    if (!value) {
      return '-';
    }
    if (isPercentage) {
      return `${value}%`;
    } else {
      return value;
    }
  };

  return (
    <div className={styles.component}>
      <div className={styles.label}>
        {label}
      </div>
      <div className={isBlurred ? 'blur' : styles.bold}>
        {TryScrambleText(formatDisplayValue(city), isBlurred)}
      </div>
      {neighbourhood &&
      <>
        <div className={isBlurred ? 'blur' : styles.bold}>
          {TryScrambleText(formatDisplayValue(neighbourhood), isBlurred)}
        </div>
        <div className={isBlurred ? 'blur' : styles.bold} style={{ color: getColourOfStat(getDifferenceInStringifiedStats(neighbourhood, city)) }}>
          {Number(TryScrambleText(getDifferenceInStringifiedStats(neighbourhood, city), isBlurred)) > 0 ? '+' : ''}{formatDisplayValue(TryScrambleText(getDifferenceInStringifiedStats(neighbourhood, city), isBlurred) as string)}
        </div>
      </>
      }
    </div>
  );
}
